import { Application, Controller } from 'stimulus'
import '@stimulus/polyfills'
import $ from 'jquery'
import 'slick-carousel'

import './component.scss'
import 'Components/refosumu/company_image/component'

const app = Application.start()

app.register('carousel', class extends Controller {
  connect () {
    $(this.element).slick(this.sliderOptions())
  }

  sliderOptions () {
    return JSON.parse(this.element.dataset.sliderOptions)
  }
})
